import { TFilterValue } from "@irohana-dev/components";
import { Dayjs } from "dayjs";
import { asStringArray } from "@/components/commons/filter-condition/filter-condition-adapter-kit";
import {
  CASE_MATCH_MULTI_SELECT_FILTER_KEYS,
  TCaseMatchFilterFormExtended,
  defaultCaseMatchFilterValues,
} from "@/features/case/components/CaseMatches/case-match-filter-shared";
import { dayjs } from "@/utils/dayjs";

export const toFilterValue = (filters: TCaseMatchFilterFormExtended): TFilterValue => {
  const value: TFilterValue = {};
  for (const [key, raw] of Object.entries(filters)) {
    if (Array.isArray(raw)) {
      if (raw.length > 0) value[key] = raw.map(String);
      continue;
    }
    if (raw === "" || raw === null || raw === undefined) continue;
    if (CASE_MATCH_MULTI_SELECT_FILTER_KEYS.includes(key as keyof TCaseMatchFilterFormExtended)) {
      value[key] = [String(raw)];
      continue;
    }
    value[key] = String(raw);
  }
  return value;
};

export const fromFilterValue = (value: TFilterValue): TCaseMatchFilterFormExtended => ({
  ...defaultCaseMatchFilterValues,
  talentNumber: (value.talentNumber as string) ?? "",
  fullName: (value.fullName as string) ?? "",
  nickName: (value.nickName as string) ?? "",
  hasOtherProposal: asStringArray(value.hasOtherProposal),
  nationalityId: asStringArray(value.nationalityId),
  gender: asStringArray(value.gender),
  ageFrom: (value.ageFrom as string) ?? "",
  ageTo: (value.ageTo as string) ?? "",
  residenceStatusId: asStringArray(value.residenceStatusId),
  periodOfStayFrom: (value.periodOfStayFrom as string) ?? "",
  periodOfStayTo: (value.periodOfStayTo as string) ?? "",
  languageTestLevelId: asStringArray(value.languageTestLevelId),
  partnerId: asStringArray(value.partnerId),
  personInChargeId: asStringArray(value.personInChargeId),
});

export const parsePeriodOfStay = (raw: string): Dayjs | null => {
  if (!raw) return null;
  const day = dayjs(raw);
  return day.isValid() ? day : null;
};
